import { Trans } from '@lingui/react/macro';
import { FilterButton, Menu } from '@pocketlaw/tetris';
import { searchTypeValues } from '../SearchModifierMenu/searchTypeValues';
export function SearchTypeModifier(props) {
    const { setModifiers, modifiers } = props;
    const values = searchTypeValues();
    const setSearchType = (value) => {
        setModifiers({
            searchType: value,
        });
    };
    const [defaultValue] = values;
    const selectedValue = values.find((value) => value.id === modifiers.searchType);
    return (<Menu.Root target={<FilterButton>
          <b>
            <Trans comment="Universal search - search type: Title">Search type:</Trans>
          </b>
          {(selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.name) || defaultValue.name}
        </FilterButton>}>
      {values.map((value) => (<Menu.ItemRadio key={value.id} checked={modifiers.searchType === value.id} onChange={() => setSearchType(value.id)}>
          <Menu.ItemText truncate={false} primary={value.name} secondary={value.description}/>
        </Menu.ItemRadio>))}
    </Menu.Root>);
}
